export default "__VITE_ASSET__iL6TYN23__"